import {getElementIndexParams} from '../helpers/elementIndex.js';

// Create the abort controller
let controller = null;

if (process.client) {
  controller = new AbortController();
}

export default {
  cancelRequests() {
    if (process.client && controller) {
      // Abort requests
      controller.abort();

      // Create new abort controller
      controller = new AbortController();
    }
  },

  searchDevelopers({searchQuery, developerIndexParams}) {
    const params = getElementIndexParams(developerIndexParams);
    params.searchQuery = searchQuery;

    // TODO: replace mocked response by real one

    const getDevelopersFixture = () => {
      const nbDevelopers = 24;
      const developers = [];

      for (let i = 0; i < nbDevelopers; i++) {
        developers[i] = {
          name: 'Developer ' + (i + 1),
        };
      }

      return developers;
    };

    const developers = getDevelopersFixture();

    return {
      data: {
        developers,
      },
    };
  },
};
